export default __webpack_public_path__ + "static/media/lysningen.36cd4384.mp4";